export var EActiveTab = /*#__PURE__*/function (EActiveTab) {
  EActiveTab["Authentication"] = "authentication";
  EActiveTab["Registration"] = "registration";
  return EActiveTab;
}({});